<ng-container *transloco="let t; read: 'rename-collection'"
  ><div class="xi-modal__container">
    <h2 class="xi-modal__title kxi-text-600 kxi-text-large">{{ t('title') }}</h2>

    <div class="xi-modal__content">
      <div class="rename-collection__input-wrapper">
        <xi-input-field
          [label]="t('collection-name')"
          [placeholder]="t('enter-here')"
          name="displayName"
          [(ngModel)]="displayName"
          required
          [status]="collectionNameStatus"
          [prePopulateStatus]="true"
          (onChange)="onValidateCollectionName()"
          [stretch]="true"
          [disabled]="collection.data.locked"
        ></xi-input-field>
      </div>
    </div>

    <div class="xi-modal__actions">
      <xi-default-button
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="cancel()"
      ></xi-default-button>

      <xi-default-button
        text="{{ t('save') }}"
        [disabled]="collectionNameHasErrors()"
        (onClick)="saveCollectionName()"
      ></xi-default-button>
    </div>
  </div>
</ng-container>
